import React from 'react';
import './OnboardingCard.css';

interface OnboardingCardProps {
  icon: string;
  description1: string;
  description2: string;
  buttonText: string;
  onButtonClick: () => void;
}

const OnboardingCard: React.FC<OnboardingCardProps> = ({ icon, description1, description2, buttonText, onButtonClick }) => {
  return (
    <div className="onboarding-card">
      <img src={icon} alt="Card Icon" className="card-icon" />
      <div className="description1">{description1}</div>
      <div className="description2">{description2}</div>
      <button className="action-button" onClick={onButtonClick}>{buttonText}</button>
    </div>
  );
};

export default OnboardingCard;
